import Link from 'next/link'
import React from 'react'

import { Avatar } from '@wartek-id/avatar'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { capitalizeFirstLetter } from 'utils/text'

import type { Playlists as PlaylistsType } from 'types/video-inspirasi'

interface PlaylistCardProps extends Omit<PlaylistsType, 'longDescription'> {
  onClick?: () => void
}

const PlaylistCard = ({
  id,
  bannerImageUrl,
  name,
  videoCount,
  shortDescription,
  reviewer,
  onClick,
}: PlaylistCardProps) => {
  return (
    <div
      onClick={() => onClick?.()}
      className="relative bg-white rounded-lg shadow-card overflow-hidden"
    >
      <div className="relative mb-5 h-28 w-full bg-black">
        {!!bannerImageUrl && (
          <img
            src={bannerImageUrl}
            className="absolute left-0 top-0 object-center object-cover w-full h-28"
            alt={name}
          />
        )}
        <div
          className="flex relative p-3 h-full justify-end"
          style={{
            background:
              'linear-gradient(0deg, rgba(0, 0, 0, .3), rgba(0, 0, 0, .3))',
          }}
        >
          <div
            className="flex items-start rounded px-2 py-1 h-[fit-content]"
            style={{ background: 'rgba(0,0,0,0.5)' }}
          >
            <Icon
              as="i"
              color="inverse"
              fontSize="small"
              style={{
                fontSize: '22px',
                width: '22px',
                height: '22px',
              }}
            >
              video_library
            </Icon>
            <Text variant="heading-sm" color="inverse" className="ml-2">
              {videoCount} Video
            </Text>
          </div>
        </div>
      </div>
      {/*Card Header*/}
      <div className="px-4 pb-4">
        <div className="mb-2">
          <Link
            href={`/video-inspirasi/playlists?id=${id}`}
            passHref
            legacyBehavior
          >
            <Text as="a" variant="heading-md" className="overlay-link">
              {name}
            </Text>
          </Link>
        </div>
        <div className="mb-2">
          <Text color="subdued">{capitalizeFirstLetter(shortDescription)}</Text>
        </div>
        <div className="flex items-center mb-1">
          <Avatar alt="" shape="circle" size="sm" src={reviewer.imageUrl} />
          <div className="ml-2">
            <Text as="span" color="subdued" variant="body-sm">
              Dikurasi oleh {reviewer.name}
            </Text>
          </div>
        </div>
      </div>
      {/*Card Body*/}
    </div>
  )
}

export default PlaylistCard
